package org.gstechnovos.jexonplastech.util

import androidx.compose.runtime.staticCompositionLocalOf
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

object Constants {

    const val WEBSITE = "https://jexonplastech.com"
    const val SECTION_WIDTH = 1920
    val LocalBreakpoint = staticCompositionLocalOf { Breakpoint.ZERO }
    const val FONT_FAMILY = "Roboto"

    const val FacebookLink = "https://jexonplastech.com"
    const val TwitterLink = "https://twitter.com"
    const val InstagramLink = "https://instagram.com"
    const val LinkedinLink = "https://linkedin.com"

    const val headerDescription =
        "We utilize latest technology to manufacture all kinds of brushes and other products with perfect designs and accuracy that makes us amongst the leading players in the industry."
    const val aboutDescription =
        "Jexon Enterprise is Western India's leading and quality maintain manufacturers of Household and Industrial Brushes. We utilize latest technology to manufacture all kinds of brushes and other products with perfect designs and accuracy that makes us amongst the leading players in the industry."

    const val LOREM_IPSUM_SHORTEST =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."

    const val LOREM_IPSUM_LONG =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."

    const val LOREM_IPSUM_SHORT =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
}

object Res {

    object Icon {
        const val web = "web_icon.svg"
        const val seo = "seo_icon.svg"
        const val design = "design_icon.svg"
        const val business = "business_icon.svg"
        const val apple = "apple_icon.svg"
        const val android = "android_icon.svg"

        const val link = "link_icon.svg"

        const val user = "user_icon.svg"
        const val shield = "shield_icon.svg"
        const val happy = "happy_icon.svg"
        const val checkmark = "checkmark_icon.svg"

        const val star = "star_icon.svg"
    }

    object Image {
        const val BACKGROUND = "background.svg"
        const val LOGO = "logo.svg"
        const val HEADER_IMAGE = "header_image.jpg"
        const val ABOUT_IMAGE = "about_image.png"

        const val portfolio1 = "portfolio1.png"
        const val portfolio2 = "portfolio2.png"
        const val portfolio3 = "portfolio3.png"
        const val portfolio4 = "portfolio4.jpg"
        const val portfolio5 = "portfolio5.png"

        const val avatar1 = "avatar1.png"
        const val avatar2 = "avatar2.png"
        const val avatar3 = "avatar3.png"
        const val avatar4 = "avatar4.png"
        const val avatar5 = "avatar5.png"
        const val avatar6 = "avatar6.png"
    }
}